import { cloneElement, ReactElement } from "react";
import { Box } from "@mui/material";
import { BaseModalComponent } from "../../../common/BaseModalComponent";
import { JobDetails } from "../../jobs-details/JobDetails";
import { Job } from "../../interfaces/job.interfaces";
import { useGetScopeOfWork } from "../../../scope-of-work/hooks/useGetScopeOfWork";
import { useModals } from "../../../../context/ModalContext";

interface JobDetailsModalProps {
  job: Job | any;
  trigger: ReactElement;
  modalKey?: string;
  wrapTrigger?: boolean;
  onJobUpdated?: () => void;
  mountContentOnOpen?: boolean;
}

export const JobDetailsModalContent = ({ job, modalKey, onJobUpdated }: { job: Job | any; modalKey: string; onJobUpdated?: () => void }) => {
  const { data } = useGetScopeOfWork({
    scopeOfWorkUid: job.scopeOfWorkUid,
  });

  return <JobDetails job={job} scopeOfWork={data} backModalKey={modalKey} onParentJobUpdated={onJobUpdated} />;
};

export const JobDetModal = ({ job, trigger, modalKey, wrapTrigger = true, onJobUpdated, mountContentOnOpen = false }: JobDetailsModalProps) => {
  console.count("render JobDetModal");

  const { openModal } = useModals();

  const normalizedJob = {
    ...job,
    id: job.jobId || job.serviceOrderId || job.id,
  };

  const finalModalKey = modalKey || `JobCard-${normalizedJob.id}`;

  const modalContent = <JobDetailsModalContent job={normalizedJob} modalKey={finalModalKey} onJobUpdated={onJobUpdated} />;

  const handleOpenJob = (event?: any) => {
    event?.stopPropagation?.();

    // En la lista solo cargo el detalle cuando ya se dio click en la card.
    openModal(finalModalKey, modalContent);
  };

  const elementTrigger = wrapTrigger ? (
    <Box sx={{ width: "100%", cursor: "pointer" }} onClick={mountContentOnOpen ? handleOpenJob : undefined}>
      {trigger}
    </Box>
  ) : mountContentOnOpen ? (
    cloneElement(trigger, {
      onClick: (event: any) => {
        trigger.props?.onClick?.(event);
        handleOpenJob(event);
      },
    })
  ) : (
    trigger
  );

  return (
    <BaseModalComponent
      modalLabel={`Job #${normalizedJob.id}`}
      modalKey={finalModalKey}
      elementTrigger={elementTrigger}
      disabled={mountContentOnOpen}
      preferModalContent={mountContentOnOpen}
    >
      {mountContentOnOpen ? null : modalContent}
    </BaseModalComponent>
  );
};
